<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-01 11:58:40
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-02 11:53:55
-->
<template>
	<div class="side-menu-box">
		<div
			class="side-item"
			:class="{ active: checkIsActive(item.fullPath) }"
			v-for="item in menus"
			:key="item.path"
			@click="menuClickHandle(item.fullPath)"
		>
			<span class="vertical-align-middle">{{ item.meta.title }}</span>
			<i class="redPoint vertical-align-middle ml-4" v-if="showRedPoint(item)"></i>
			<i class="i-vip ml-2" v-if="showVipIcon(item)"></i>

			<!-- 临时加上, 商品公海上线一段时间后去掉 -->
			<i class="i-fun-hot ml-4" v-else-if="showHotIcon(item)"></i>
			<!-- new标签,基于newIconUrl 这个数组来判断显示不显示  -->
			<i class="i-new ml-4" v-else-if="showNewIcon(item)"></i>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
export default {
	props: {
		vipUrl: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			menus: [],
			hotIconUrl: ['promotion', 'releasePlatform', 'commercial'],
			newIconUrl: ['clueSeas', 'talentObtain'],
		};
	},
	mounted() {
		this.menus = this.vuex_subMenuList;
	},
	computed: {
		...mapState(['vuex_subMenuList', 'vuex_newFuncsViewed']),
		...mapGetters(['showSideMenu', 'tenantInfo']),
		activePath() {
			const matchedPath = [...this.$route.matched];
			const path = matchedPath.map(item => item.path);
			return path;
		},
		watchedObj() {
			return {
				subMenuList: this.vuex_subMenuList,
				viewedList: this.vuex_newFuncsViewed,
			};
		},
	},
	watch: {
		watchedObj: {
			handler(val) {
				this.menus = val.subMenuList;
			},
			deep: true,
		},
	},
	methods: {
		menuClickHandle(path) {
			if (this.$route.path === path) return;
			// 只能传完成的地址，否则匹配不上地址
			this.$router.push(`/${path}`.replace(/\/+/g, '/'));
		},
		checkIsActive(path) {
			return this.activePath.includes(path) ? 'active' : '';
		},
		showRedPoint(route) {
			return !this.vuex_newFuncsViewed.includes(route.fullPath) && route.meta.newFlag;
		},
		showHotIcon(item) {
			return this.hotIconUrl.includes(item.path);
		},
		showNewIcon(item) {
			return this.newIconUrl.includes(item.path);
		},
		showVipIcon(item) {
			const path = ['/order/list', '/cooperationProgress/list'].includes(item.fullPath) ? item.fullPath.split('/')[1] : item.path;
			return this.tenantInfo.friendVersion && this.vipUrl.includes(path);
		},
	},
};
</script>
<style lang="less" scoped>
.side-item {
	font-family: PingFangSC-Regular, PingFang SC;
	font-size: 14px;
	height: 40px;
	line-height: 40px;
	border-radius: 4px;
	position: relative;
	color: @color-text-primary;
	background-color: @color-white;
	padding-left: 16px;
	vertical-align: middle;
	cursor: pointer;
	&:nth-child(n + 2) {
		margin-top: 4px;
	}
	&:hover {
		background-color: fadeout(@color-primary, 92%);
	}
	&.active {
		color: @color-primary;
		background-color: fadeout(@color-primary, 92%);
		&::before {
			content: '';
			width: 2px;
			height: 12px;
			border-radius: 1px;
			background-color: @color-primary;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
		}
	}
}
.side-menu-box {
	height: calc(100vh - @header-height);
	background-color: @color-white;
	padding: 8px;
	box-sizing: border-box;
}
.redPoint {
	display: inline-block;
	width: 6px;
	height: 6px;
	border-radius: 100%;
	background-color: @color-danger;
}
.vertical-align-middle {
	vertical-align: middle;
}
.i-new {
	position: absolute;
	right: 0;
}
</style>
